/**
 * Canonical frequency period values as stored on tasks (see frequency.js BoundSimpleCombo).
 * @type {ReadonlySet<string>}
 */
const FREQUENCY_PERIOD_CANONICAL = new Set(["Hour", "Day", "Week", "Month", "Year", "Unknown"])

/**
 * Map common mixed-case / legacy variants to canonical period id.
 * @param {string} [value]
 * @returns {string}
 */
export function normalizeFrequencyPeriod(value) {
    if (value == null || value === "") return ""
    const s = String(value).trim()
    if (FREQUENCY_PERIOD_CANONICAL.has(s)) return s
    const lower = s.toLowerCase()
    const map = {
        hour: "Hour",
        day: "Day",
        week: "Week",
        month: "Month",
        year: "Year",
        unknown: "Unknown",
    }
    if (map[lower]) return map[lower]
    return s
}

/**
 * Tokens that must not be case-normalized (skill codes, acronyms, etc.).
 * @param {string} value
 * @returns {boolean}
 */
export function isPreserveCaseToken(value) {
    if (value == null) return false
    const s = String(value)
    if (/^0U$/i.test(s)) return true
    if (/^UoM$/i.test(s)) return true
    if (/^[A-Z0-9]{2,8}$/.test(s) && /[0-9]/.test(s)) return true
    return false
}
